import React from 'react'
import { useTranslation } from 'react-i18next'

type props = {
  title: string
}

export default function ErrorPage({ title }: props) {
  const { t } = useTranslation()
  return (
    <main className="step-0">
      <h4 className="subtitle">{title}</h4>
      <h1>Oops!</h1>
      <div className="paragraph">{t<string>('common.unexpectedError')}</div>
    </main>
  )
}
